module.exports = __webpack_public_path__ + "static/media/wood_opendoor_left.6bc25059.png";